import styled from 'styled-components/macro';

export const Container = styled.div`
  position: absolute;
  width: 60px;
  height: 60px;
  bottom: 20px;
  right: 24px;
`;
